import { useContext } from 'react'
import { PricesContext } from '../contexts/PricesContext'

const usePrices = () => {
  return useContext(PricesContext)
}

export default usePrices
